/* eslint-disable @typescript-eslint/no-inferrable-types */
import { JournalDataEntryForm, PaginatedJournals } from "types/model.types";
import { authApi } from "./";

export const getCreditJournals = async (
  pageNumber: number = 1,
  pageSize: number = 30,
): Promise<void | PaginatedJournals> => {
  const { data } = await authApi.post<PaginatedJournals>("crjournal/get", {
    pageNumber,
    pageSize,
  });
  return data;
};

export const submitJournal = async (
  payload: any,
): Promise<void | JournalDataEntryForm> => {
  const { data } = await authApi.post<JournalDataEntryForm>(
    "crjournal/submit",
    payload,
  );
  return data;
};
export const deleteAdminCreditJnl = async (id: number): Promise<void | any> => {
  const { data } = await authApi.post<any>(`crjournal/deleteAdminCrJournal`, {
    id,
  });
  return data;
};
/**
 *
 * @param id Get credit journal records by ID
 * @returns
 */
export const getJournalById = (id: number): Promise<JournalDataEntryForm> => {
  return authApi
    .post<JournalDataEntryForm>("crjournal/getJournalById", { id })
    .then((res) => res.data);
};
export const deleteJournalDetails = async (
  journalId: number,
  journalDetailIds: number[],
): Promise<void | any> => {
  const { data } = await authApi.post<any>("crjournal/deleteDetails", {
    journalId,
    journalDetailIds,
  });
  return data;
};
